const styObj = {
  default: {
    '--confirm-btn-theme': '#a338fc',
  },
  kiko: {
    '--confirm-btn-theme': '#ffe242',
  },
}

export const pageCssVars = {
  methods: {
    cssVars() {
      if (this.packageName) {
        if (styObj[this.packageName]) {
          return styObj[this.packageName]
        } else {
          return styObj['default']
        }
      }
      return {}
    },
  },
}
